import * as ActionTypes from "../action-types";

const billing_defaultState = {
  byID: {},
  byCoid: {},
  allIDs: [],
};

export const billing = (state = billing_defaultState, action) => {
  let newState = JSON.parse(JSON.stringify(state));
  if (!action) return newState;
  switch (action.type) {
    case ActionTypes.BILLING_GET_ALL: {
      const billings = action.billing;

      billings &&
        billings.length &&
        billings.map((billing) => {
          const { billid } = billing;
          newState.byID[billid] = billing;

          if (!newState.allIDs.includes(billid)) newState.allIDs.push(billid);
          return null;
        });

      return newState;
    }
    case ActionTypes.BILLING_GET_ALL_BY_COID: {
      const billings = action.billing;

      billings &&
        billings.length &&
        billings.map((billing) => {
          const { billid } = billing;
          newState.byCoid[billid] = billing;

          if (!newState.allIDs.includes(billid)) newState.allIDs.push(billid);
          return null;
        });

      return newState;
    }
    case ActionTypes.UPDATE_BILLING: {
      const billing = action.billing;
      const role = action.role;
      const { billid } = billing;

      if (billid) {
        if (role === "EMR") {
          newState.byCoid[billid] = billing;
        } else {
          newState.byID[billid] = billing;
        }
      }
      return newState;
    }
    case ActionTypes.BULK_PUBLISH: {
      const billings = action.billings;

      if (Array.isArray(billings)) {
        billings.forEach((bill) => {
          const { billid } = bill;

          newState.byID[billid] = { ...newState.byID[billid], ...bill };
        });
      }

      return newState;
    }
    default: {
      return state;
    }
  }
};
